// IP-safe themed "worlds" for the child environment.
// Each theme drives colors (CSS vars), fonts, mascot, background and Dutch terminology.

export const THEMES = {
  arena: {
    id: "arena",
    name: "Arena",
    tagline: "Strijd je naar de top!",
    mascot: "🤖",
    mode: "dark",
    bgClass: "world-arena",
    fonts: { heading: "'Bungee', cursive", body: "'Exo 2', sans-serif" },
    colors: {
      surface: "#141419", surface2: "#1E1E26", border: "#2A2A35",
      primary: "#FF3366", accent: "#00FFCC", success: "#39FF14",
      text: "#F0F0F5", muted: "#8A8A93",
      onPrimary: "#FFFFFF", onAccent: "#08110F",
    },
    terms: {
      greeting: "Klaar voor de strijd", level: "Rang", xp: "PP", coins: "Munten", coinIcon: "💎",
      streak: "Combo", recommended: "Jouw volgende battle", nextCta: "Volgende battle!",
      allExercises: "Alle battles", chooseTheme: "Kies je wereld", theme: "Wereld",
      challenges: "Uitdagingen", badges: "Trofeeën", skills: "Vaardigheden",
      leaderboard: "Ranglijst", leaderboardSub: "De beste strijders van de Arena",
      results_great: "Overwinning!", results_good: "Goed gevochten!", results_low: "Train verder, strijder!",
      again: "Nog een battle", dashboard: "Basis", loading: "Battle wordt geladen...",
      loadingMsgs: ["Het strijdveld opbouwen...", "Vijanden activeren...", "Bijna klaar voor de strijd..."],
    },
  },
  reddingsteam: {
    id: "reddingsteam",
    name: "Reddingsteam",
    tagline: "Iedereen kan een held zijn!",
    mascot: "🐶",
    mode: "light",
    bgClass: "world-reddingsteam",
    fonts: { heading: "'Fredoka', sans-serif", body: "'Nunito', sans-serif" },
    colors: {
      surface: "#FFFFFF", surface2: "#E8F4FF", border: "#DFE6E9",
      primary: "#FF6B6B", accent: "#4ECDC4", success: "#2BB673",
      text: "#2D3436", muted: "#636E72",
      onPrimary: "#FFFFFF", onAccent: "#053B36",
    },
    terms: {
      greeting: "Hoi held", level: "Klasse", xp: "Moed", coins: "Munten", coinIcon: "⭐",
      streak: "Reddingsreeks", recommended: "Jouw volgende reddingsactie", nextCta: "Naar de actie!",
      allExercises: "Alle reddingsacties", chooseTheme: "Kies je wereld", theme: "Wereld",
      challenges: "Uitdagingen", badges: "Insignes", skills: "Vaardigheden",
      leaderboard: "Helden-ranglijst", leaderboardSub: "De dapperste helden van het team",
      results_great: "Held van de dag!", results_good: "Goed gered!", results_low: "Blijf oefenen, held!",
      again: "Nog een actie", dashboard: "Basis", loading: "Reddingsactie wordt klaargemaakt...",
      loadingMsgs: ["De missie voorbereiden...", "De pups op pad sturen...", "Bijna klaar om te redden..."],
    },
  },
  ruimte: {
    id: "ruimte",
    name: "Ruimte",
    tagline: "Verken het hele universum!",
    mascot: "👽",
    mode: "dark",
    bgClass: "world-ruimte",
    fonts: { heading: "'Chakra Petch', sans-serif", body: "'Outfit', sans-serif" },
    colors: {
      surface: "#1F2833", surface2: "#26303D", border: "#2B3245",
      primary: "#66FCF1", accent: "#FFCB47", success: "#45A29E",
      text: "#FFFFFF", muted: "#8C92AC",
      onPrimary: "#0B0C10", onAccent: "#0B0C10",
    },
    terms: {
      greeting: "Hallo ruimtereiziger", level: "Baan", xp: "Sterrenstof", coins: "Munten", coinIcon: "☄️",
      streak: "Lichtjaren", recommended: "Jouw volgende expeditie", nextCta: "Lanceer!",
      allExercises: "Alle verkenningen", chooseTheme: "Kies je wereld", theme: "Wereld",
      challenges: "Missies", badges: "Medailles", skills: "Vaardigheden",
      leaderboard: "Ruimte-ranglijst", leaderboardSub: "De beste ontdekkers van het heelal",
      results_great: "Missie geslaagd!", results_good: "Goede vlucht!", results_low: "Train verder, ruimtereiziger!",
      again: "Nog een vlucht", dashboard: "Ruimteschip", loading: "Verkenning wordt geladen...",
      loadingMsgs: ["De raket vullen...", "Coördinaten berekenen...", "Aftellen tot lancering..."],
    },
  },
  magisch: {
    id: "magisch",
    name: "Magisch Bos",
    tagline: "Ontdek de magie van woorden!",
    mascot: "🦉",
    mode: "light",
    bgClass: "world-magisch",
    fonts: { heading: "'Caveat Brush', cursive", body: "'Quicksand', sans-serif" },
    colors: {
      surface: "#FFFFFF", surface2: "#F5ECCF", border: "#E4D8B4",
      primary: "#8B5A2B", accent: "#D4AF37", success: "#6B8E23",
      text: "#3E2723", muted: "#8D6E63",
      onPrimary: "#FFFFFF", onAccent: "#3E2723",
    },
    terms: {
      greeting: "Welkom, jonge tovenaar", level: "Tovenaarsgraad", xp: "Magie", coins: "Munten", coinIcon: "🌰",
      streak: "Toverreeks", recommended: "Jouw volgende avontuur", nextCta: "Sla de bladzijde om!",
      allExercises: "Alle toverspreuken", chooseTheme: "Kies je wereld", theme: "Wereld",
      challenges: "Beproevingen", badges: "Amuletten", skills: "Vaardigheden",
      leaderboard: "Tovenaars-ranglijst", leaderboardSub: "De machtigste tovenaars van het bos",
      results_great: "Betovering geslaagd!", results_good: "Knap getoverd!", results_low: "Oefen je spreuken verder!",
      again: "Nog een spreuk", dashboard: "Boomhut", loading: "Toverspreuk wordt gebrouwen...",
      loadingMsgs: ["Magische woorden verzamelen...", "De spreuk uitspreken...", "Bijna betoverd..."],
    },
  },
};

export const THEME_LIST = Object.values(THEMES);

export function getDefaultTheme(level) {
  // Age-appropriate default world by groep; all worlds remain selectable.
  const s = String(level || "");
  const g = (s.length >= 2 && "BME".includes(s[0]) && /\d/.test(s[1])) ? Number(s[1]) : 5;
  if (g <= 4) return "magisch";
  if (g <= 6) return "reddingsteam";
  return "arena";
}
